import React from 'react';
import { CheckCircle } from 'lucide-react';
import { armedSecurityInfo, unarmedSecurityInfo, vehiclePatrolInfo } from '../data/mock';

const SecuritySection = ({ data, reversed = false }) => {
  return (
    <div className={`grid lg:grid-cols-2 gap-12 items-center ${reversed ? 'lg:flex-row-reverse' : ''}`}>
      {/* Image */}
      <div className={`relative ${reversed ? 'lg:order-2' : ''}`}>
        <div className="relative rounded-2xl overflow-hidden shadow-2xl">
          <img 
            src={data.image} 
            alt={data.title}
            className="w-full h-[400px] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-slate-900/50 to-transparent"></div>
        </div>
        {/* Decorative Element */}
        <div className={`absolute -z-10 w-full h-full bg-orange-500/20 rounded-2xl top-6 ${reversed ? '-left-6' : '-right-6'}`}></div>
      </div>

      {/* Content */}
      <div className={reversed ? 'lg:order-1' : ''}>
        <h3 className="text-3xl md:text-4xl font-bold text-white mb-6">
          {data.title}
        </h3>
        <div className="space-y-6">
          {data.points.map((point, index) => (
            <div key={index} className="flex gap-4">
              <div className="flex-shrink-0">
                <div className="w-8 h-8 bg-orange-500/20 rounded-full flex items-center justify-center">
                  <CheckCircle className="w-5 h-5 text-orange-500" />
                </div>
              </div>
              <div>
                <h4 className="text-lg font-semibold text-white mb-2">{point.title}</h4>
                <p className="text-gray-400 leading-relaxed">{point.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const SecurityTypes = () => {
  return (
    <section className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Armed Security */}
        <div className="mb-24">
          <SecuritySection data={armedSecurityInfo} />
        </div>

        {/* Unarmed Security */}
        <div className="mb-24">
          <SecuritySection data={unarmedSecurityInfo} reversed />
        </div>

        {/* Vehicle Patrol */}
        <div>
          <SecuritySection data={vehiclePatrolInfo} />
        </div>
      </div>
    </section>
  );
};

export default SecurityTypes;